angular.module("vgresiduos").controller("DisposalDriverCtrl", [
	"$scope",
	"$rootScope",
	"$state",
	"httpService",
	"supplierDriverService",
	"dialogService",
	"disposalService",
	"supplierService",
	"disposalStepControlService",
	function (
		$scope,
		$rootScope,
		$state,
		httpService,
		supplierDriverService,
		dialogService,
		disposalService,
		supplierService,
		disposalStepControlService
	) {
		"use strict";

		$scope.supplierDriverPermission = false;

		this.$onInit = function () {
			loadDrivers();
		};

		$scope.changeDriver = function (driver) {
			$scope.destinationModel.Driver = driver;

			validateDriver();

			if ($scope.ctrl.mustUpdateSlip) {
				$scope.updateSlip(
					$scope.stepsEnum.B,
					$scope.destinationModel.Driver ? $scope.destinationModel.Driver.name : null
				);
			}
		};

		function validateDriver() {
			if (!$scope.canValidateDisposal()) {
				return;
			}

			const dto = $scope.createValidateDto($scope.destinationModel.Transporter);
			httpService.getDTOFromServiceV2(disposalService.validateDisposal, dto).then(function (response) {
				setValidationResult(response.Validations);
				$scope.updateValidationList(response.Validations);

				disposalStepControlService.processTransporterValidations(response.Validations, $scope, true);
			});
		}

		function setDriverModel(supplierCode, driverId) {
			const foundDriver = $scope.drivers.find((d) => d.id == driverId);
			if (foundDriver != null) {
				$scope.destinationModel.Driver = foundDriver;
			} else {
				return trySetDriverModelByGet(supplierCode, driverId);
			}
		}

		function loadDrivers() {
			if (!$scope.destinationModel.Transporter) {
				return;
			}

			const supplierCode = $scope.destinationModel.Transporter.Code;

			httpService
				.getDTOFromServiceV2(supplierService.getOrganizationSupplierByCode, { supplierCode: supplierCode })
				.then(function (supplier) {
					$scope.supplierDriverPermission = supplierService.hasSupplierPermission(
						supplier,
						null,
						Vgr.systemPermissions.SupplierVehicleAndDriver
					);
				});

			return httpService.getListFromServiceCore(supplierDriverService.listDrivers, supplierCode).then(
				function (response) {
					response.list.forEach((driver) => {
						formatDriverData(driver);
					});

					let disposalCurrentDriverId = "";
					if ($scope.destinationModel.Driver) {
						disposalCurrentDriverId = $scope.destinationModel.Driver.Id;
					}
					$scope.drivers = response.list.filter((v) => v.active || v.id == disposalCurrentDriverId);
					if (disposalCurrentDriverId) {
						setDriverModel(supplierCode, disposalCurrentDriverId);
					}
				},
				function () {
					// do nothing
				}
			);
		}

		function formatDriverData(driver) {
			let certificate = null;
			if (driver.certificates?.length > 0) {
				certificate = driver.certificates.find((c) => c.active && new Date(c.dueDate) > new Date());
				if (!certificate) {
					certificate = driver.certificates[driver.certificates.length - 1];
				}
			}

			if (certificate) {
				driver.certificateNumber = certificate.number;
			} else {
				driver.certificateNumber = "";
			}

			driver.driverLicenseDate = driver.driverLicenseDate
				? Vgr.util.dateToString(new Date(driver.driverLicenseDate))
				: "";
		}

		function trySetDriverModelByGet(supplierCode, driverId) {
			return httpService
				.getDTOFromServiceV2(supplierDriverService.getDriver, { supplierCode, driverId })
				.then(function (supplierDriver) {
					formatDriverData(supplierDriver);

					$scope.drivers = [...$scope.drivers, supplierDriver];
					$scope.destinationModel.Driver = supplierDriver;
				});
		}

		$scope.openDisposalDriverPopup = function () {
			if (!$scope.destinationModel.Transporter) {
				$rootScope.$broadcast(Vgr.constants.evtShowErrorMessage, $rootScope.labels.SELECT_TRANSPORTER);
				return;
			}

			openDriverPopup();
		};

		function openDriverPopup() {
			const params = {
				supplierCode: $scope.destinationModel.Transporter.Code
			};

			dialogService
				.showDialogFromTemplateV2(
					"views/newAngular/suppliers/driver/createDriverPopup/createDriverPopup.html",
					"createDriverPopupCtrl",
					"#angular-popup-small",
					params,
					true
				)
				.then(onDriverPopupCreate, function () {
					// do nothing
				});
		}

		function onDriverPopupCreate(driver) {
			driver.driverLicenseDate = driver.driverLicenseDate
				? Vgr.util.dateToString(new Date(driver.driverLicenseDate))
				: "";
			$scope.drivers.push(driver);
			$scope.destinationModel.Driver = driver;
		}

		$scope.hasEditPermissionSupplierAndDestination = function () {
			return $scope.editPermission && $scope.supplierDriverPermission;
		};

		function setValidationResult(validations) {
			setDriverLicenseValidationResult(validations);
			setDriverMoppValidationResult(validations);
		}

		function setDriverLicenseValidationResult(validations) {
			$scope.disposalValidations.DriverValidate = {
				Image: null,
				FirstDescription: null,
				SecondDescription: null,
				ButtonDescription: null,
				IsOK: null
			};

			const validation = validations.find(
				(va) =>
					va.Type == Vgr.enumerations.validation.DriverLicenseWithoutExpirationDate ||
					va.Type == Vgr.enumerations.validation.DriverLicenseExpired
			);
			if (validation) {
				$scope.disposalValidations.DriverValidate.Image = "img/destination/driverInvalidLicense.png";
				$scope.disposalValidations.DriverValidate.FirstDescription =
					$scope.labels.DISPOSAL_VALIDATIONS_DESCRIPTION_ENUM[validation.Type].toUpperCase();
				$scope.disposalValidations.DriverValidate.IsOK = false;
				$scope.disposalValidations.DriverValidate.ButtonClick = openDisposalQuitPopup;
				$scope.disposalValidations.DriverValidate.ButtonDescription = $scope.labels.DISPOSAL_DRIVER_EDIT;
			}
		}

		function setDriverMoppValidationResult(validations) {
			$scope.disposalValidations.MoppValidate = {
				Image: null,
				FirstDescription: null,
				SecondDescription: null,
				IsOK: null
			};

			const validation = validations.find(
				(validation) =>
					validation.Type == Vgr.enumerations.validation.DriverWithoutMopp ||
					validation.Type == Vgr.enumerations.validation.DriverMoppExpired
			);

			if (validation) {
				$scope.disposalValidations.MoppValidate.Image = "img/destination/invalidMOPP.png";
				$scope.disposalValidations.MoppValidate.FirstDescription =
					$scope.labels.DISPOSAL_VALIDATIONS_DESCRIPTION_ENUM[validation.Type].toUpperCase();
				$scope.disposalValidations.MoppValidate.IsOK = false;
				$scope.disposalValidations.DriverValidate.ButtonDescription = $scope.labels.DISPOSAL_DRIVER_EDIT;
				$scope.disposalValidations.DriverValidate.ButtonClick = openDisposalQuitPopup;
			}
		}

		function goToSupplierEdit() {
			$state.go("supplierEdit", {
				id: $scope.destinationModel.Transporter.Code,
				tab: 4
			});
		}

		function openDisposalQuitPopup() {
			$scope.toQuitPopup = {
				Text: $scope.labels.DISPOSAL_QUIT_POPUP_TEXT,
				Action: goToSupplierEdit
			};
			const dialog = dialogService
				.showDialogFromTemplateWithScope(
					null,
					"views/destination/popups/disposalQuitPopup/disposalQuitPopup_template.html",
					"DisposalQuitPopupCtrl",
					$scope,
					"#disposal-popup-small",
					true,
					function () {}
				)
				.then(
					function () {},
					function () {}
				);
			$scope.dialog = dialog;
		}

		const transporterWatch = $scope.$watch("destinationModel.Transporter", function (newValue, oldValue) {
			if (newValue && newValue != oldValue) {
				loadDrivers();
			}
		});

		$scope.$on("$destroy", function () {
			// disable the listener
			transporterWatch();
			// nullify the DOM-bound model
			$scope.domElement = null;
		});

		$scope.getToolTipMessageDriver = function () {
			return $scope.hasEditPermissionSupplierAndDestination()
				? $rootScope.labels.ADD_DRIVER
				: $rootScope.labels.NOT_PERMISSION_EDIT_DRIVER;
		};
	}
]);
